"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserColor = exports.generateBufferCustom = exports.generateCodeChallenge = exports.generateCodeVerifier = exports.getIntegration = exports.getRedirectUrl = exports.buildSumoAdminUrl = exports.buildSalesForceInstanceUrl = exports.buildSalesForceLoginUrl = exports.getSalesForceSubDomain = exports.handleAPIRequest = exports.convertMsToTimeUnit = exports.convertTimeToMsWithTimeUnit = exports.bufferTimeConvert = exports.isSameEmail = void 0;
const constants_1 = require("@/app/shared/constants");
const colors_1 = require("@/app/shared/constants/colors");
const location_1 = require("@/app/shared/constants/scheduler/location");
const helpers_1 = require("@/app/shared/helpers");
const path_1 = require("@/app/shared/router/path");
const aws_amplify_1 = require("aws-amplify");
function isSameEmail(email1, email2) {
    return email1?.toLowerCase() === email2?.toLowerCase();
}
exports.isSameEmail = isSameEmail;
exports.bufferTimeConvert = {
    fromDurationToNumber(durationValue) {
        return parseInt(durationValue.replace("MINUTE" /* DurationTimeUnit.MINUTE */, ''));
    },
    fromStringToEnum(buffer) {
        const number = parseInt(buffer?.replace('m', '') || '0');
        return number ? ("MINUTE" /* DurationTimeUnit.MINUTE */ + number) : "NONE" /* SchedulerBufferTime.NONE */;
    },
    fromStringToNumber(buffer) {
        return this.fromEnumToNumber(this.fromStringToEnum(buffer));
    },
    fromStringToMs(buffer) {
        return this.fromStringToNumber(buffer) * helpers_1.time.minute;
    },
    fromEnumToNumber(bufferValue) {
        return bufferValue === "NONE" /* SchedulerBufferTime.NONE */ ? 0 : Number(bufferValue.replace("MINUTE" /* DurationTimeUnit.MINUTE */, ''));
    },
    fromEnumToMs(bufferValue = "NONE" /* SchedulerBufferTime.NONE */) {
        return this.fromEnumToNumber(bufferValue) * helpers_1.time.minute;
    },
    fromEnumToString(bufferValue) {
        return this.fromNumberToString(this.fromEnumToNumber(bufferValue));
    },
    fromNumberToString(bufferValue) {
        return bufferValue ? bufferValue + 'm' : null;
    },
};
const convertTimeToMsWithTimeUnit = (duration = 0, timeUnit = constants_1.TimeUnit.MINUTE) => {
    if (!duration || !timeUnit)
        return 0;
    switch (timeUnit) {
        case constants_1.TimeUnit.MINUTE:
            return duration * helpers_1.time.minute;
        case constants_1.TimeUnit.HOUR:
            return duration * helpers_1.time.hour;
        case constants_1.TimeUnit.DAY:
            return duration * helpers_1.time.day;
        default:
            throw new Error('Invalid time unit');
    }
};
exports.convertTimeToMsWithTimeUnit = convertTimeToMsWithTimeUnit;
const convertMsToTimeUnit = (ms, timeUnit = constants_1.TimeUnit.MINUTE) => {
    if (!ms || !timeUnit)
        return 0;
    switch (timeUnit) {
        case constants_1.TimeUnit.MINUTE:
            return ms / helpers_1.time.minute;
        case constants_1.TimeUnit.HOUR:
            return ms / helpers_1.time.hour;
        case constants_1.TimeUnit.DAY:
            return ms / helpers_1.time.day;
        default:
            throw new Error('Invalid time unit');
    }
};
exports.convertMsToTimeUnit = convertMsToTimeUnit;
async function handleAPIRequest(requestPath, requestData) {
    const requestBody = requestData;
    const USER_CONTEXT_PARAM = 'userContext';
    requestBody[USER_CONTEXT_PARAM] = helpers_1.Storage.Local.get(helpers_1.Storage.Key.USER_CONTEXT) || '';
    try {
        const result = await aws_amplify_1.API.post('publicApi', requestPath, {
            body: requestBody,
        });
        if (result[USER_CONTEXT_PARAM]) {
            helpers_1.Storage.Local.set(helpers_1.Storage.Key.USER_CONTEXT, result[USER_CONTEXT_PARAM]);
        }
        return result;
    }
    catch (error) {
        console.error(`Error making API request to ${requestPath}:`, error);
        throw error;
    }
}
exports.handleAPIRequest = handleAPIRequest;
const getSalesForceSubDomain = () => {
    return helpers_1.Storage.Local.get(helpers_1.Storage.Key.SERVER_ENVIRONMENT) === "PRODUCTION" /* ServerEnvironment.PRODUCTION */ ? 'login' : 'test';
};
exports.getSalesForceSubDomain = getSalesForceSubDomain;
const buildSalesForceLoginUrl = (env, path = '/', parameters) => {
    return helpers_1.query.set(`https://${env === "PRODUCTION" /* ServerEnvironment.PRODUCTION */ ? 'login' : 'test'}.salesforce.com${path}`, parameters);
};
exports.buildSalesForceLoginUrl = buildSalesForceLoginUrl;
const buildSalesForceInstanceUrl = (origin, path, parameters) => {
    return helpers_1.query.set(`${origin}${path}`, parameters);
};
exports.buildSalesForceInstanceUrl = buildSalesForceInstanceUrl;
const buildSumoAdminUrl = (path = '/', parameters) => {
    return helpers_1.query.set(`https://admin.omnito.ai${path}`, parameters);
};
exports.buildSumoAdminUrl = buildSumoAdminUrl;
const getRedirectUrl = (integrationType) => {
    const links = {
        [location_1.IntegrationType.GOOGLE_CALENDAR]: path_1.PathExtension.REDIRECT_GOOGLE,
        [location_1.IntegrationType.MICROSOFT_CALENDAR]: path_1.PathExtension.REDIRECT_MICROSOFT,
        [location_1.IntegrationType.SALESFORCE]: path_1.PathExtension.REDIRECT_SALESFORCE,
    };
    return decodeURIComponent(links[integrationType]);
};
exports.getRedirectUrl = getRedirectUrl;
const getIntegration = (member) => {
    const integrations = {
        ["SALESFORCE" /* MemberType.SALESFORCE */]: "SALESFORCE" /* Integration.SALESFORCE */,
        ["HUBSPOT" /* MemberType.HUBSPOT */]: "HUBSPOT" /* Integration.HUBSPOT */,
        ["MICROSOFT_CONTACTS" /* MemberType.MICROSOFT_CONTACTS */]: "MICROSOFT" /* Integration.MICROSOFT */,
        ["GOOGLE_CONTACTS" /* MemberType.GOOGLE_CONTACTS */]: "GOOGLE" /* Integration.GOOGLE */,
    };
    return member.type && integrations[member.type];
};
exports.getIntegration = getIntegration;
function generateCodeVerifier() {
    const array = new Uint8Array(32);
    window.crypto.getRandomValues(array);
    return btoa(String.fromCharCode(...array)).replace(/[\+\/=]/g, '');
}
exports.generateCodeVerifier = generateCodeVerifier;
async function generateCodeChallenge(code_verifier) {
    const encoder = new TextEncoder();
    const data = encoder.encode(code_verifier);
    const digest = await window.crypto.subtle.digest('SHA-256', data);
    return btoa(String.fromCharCode(...new Uint8Array(digest)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
}
exports.generateCodeChallenge = generateCodeChallenge;
const generateBufferCustom = (bufferBefore, bufferAfter, availabilityCustom) => {
    const bufferEvents = [];
    if (bufferBefore !== "NONE" /* SchedulerBufferTime.NONE */ || bufferAfter !== "NONE" /* SchedulerBufferTime.NONE */) {
        availabilityCustom.forEach((appointment, index) => {
            const start = new Date(appointment.start);
            const end = new Date(appointment.end);
            const eventId = 'id' in appointment ? appointment.id : `event-${index}`;
            if (bufferBefore !== "NONE" /* SchedulerBufferTime.NONE */) {
                const bufferMinutes = exports.bufferTimeConvert.fromEnumToNumber(bufferBefore);
                const bufferStart = new Date(start.getTime() - bufferMinutes * 60000);
                bufferEvents.push({
                    id: `buffer-before-${eventId}`,
                    title: `Pre-Buffer Time (${bufferMinutes}m)`,
                    start: bufferStart.toISOString(),
                    end: start.toISOString(),
                    backgroundColor: 'var(--orange-200)',
                    borderColor: 'var(--orange-300)',
                    display: 'background',
                    extendedProps: {
                        type: 'BUFFER_BEFORE',
                        originalEventId: eventId,
                    },
                });
            }
            if (bufferAfter !== "NONE" /* SchedulerBufferTime.NONE */) {
                const bufferMinutes = exports.bufferTimeConvert.fromEnumToNumber(bufferAfter);
                const bufferEnd = new Date(end.getTime() + bufferMinutes * 60000);
                bufferEvents.push({
                    id: `buffer-after-${eventId}`,
                    title: `Post-Buffer Time (${bufferMinutes}m)`,
                    start: end.toISOString(),
                    end: bufferEnd.toISOString(),
                    backgroundColor: 'var(--orange-200)',
                    borderColor: 'var(--orange-300)',
                    display: 'background',
                    extendedProps: {
                        type: 'BUFFER_AFTER',
                        originalEventId: eventId,
                    },
                });
            }
        });
    }
    return bufferEvents;
};
exports.generateBufferCustom = generateBufferCustom;
const getUserColor = (userId, userColors) => {
    if (!userId || !userColors)
        return { id: userId, ...colors_1.FALLBACK_COLOR };
    switch (userId) {
        case userColors.host.id:
            return userColors.host;
        case userColors.mainGuest.id:
            return userColors.mainGuest;
        case userColors.guests.find((guest) => guest.id === userId)?.id:
            return userColors.guests.find((guest) => guest.id === userId);
        default:
            return { id: userId, ...colors_1.FALLBACK_COLOR };
    }
};
exports.getUserColor = getUserColor;
